import { observer } from 'mobx-react'
import { useContext } from 'react'

import icon from '@/assets/images/icon.png'
import logo from '@/assets/images/logo.png'
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from '@/components/elements/sidebar'
import { useEntityAccess } from '@/hooks/useEntityAccess'
import { usePublishedFaqs } from '@/hooks/usePublishedFaqs'
import { router } from '@/routes'
import { RootStoreContext } from '@/stores/RootStore'
import { UserStoreContext } from '@/stores/UserStore'

import { Nav } from './nav'
import { NavUser } from './nav-user'

const AppSidebar = observer(({ ...props }) => {
  const { activeEntity, activeOrganization, isXverseAdmin, isXverseInstructorCandidate, user } =
    useContext(UserStoreContext)
  const { clearStore } = useContext(RootStoreContext)
  const { entityAccess, isEntityAccessResolved } = useEntityAccess(activeEntity)

  // The FAQs nav item only exists once RescueX has published an FAQ (RSCX-353).
  const { hasPublishedFaqs } = usePublishedFaqs({ enabled: !!user?.id && !!activeEntity })

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader className="group">
        <div className="relative h-8 w-auto self-center transition-transform duration-150">
          <img
            src={logo}
            alt="RescueX Logo"
            className="block h-8 group-data-[state=collapsed]:hidden"
          />
          <img
            src={icon}
            alt="RescueX Logo"
            className="hidden h-8 group-data-[state=collapsed]:block"
          />
        </div>
      </SidebarHeader>

      <SidebarContent>
        <Nav
          allRoutes={router.routes}
          activeEntity={activeEntity}
          activeOrganization={activeOrganization}
          isXverseAdmin={isXverseAdmin}
          isXverseInstructorCandidate={isXverseInstructorCandidate}
          roles={user?.entityRoles}
          entityAccess={entityAccess}
          entityAccessResolved={isEntityAccessResolved}
          hasPublishedFaqs={hasPublishedFaqs}
        />
      </SidebarContent>

      <SidebarFooter>{user?.id && <NavUser clearStore={clearStore} user={user} />}</SidebarFooter>
      <SidebarRail />
    </Sidebar>
  )
})

export default AppSidebar
